import { FlatList, StyleSheet, View } from 'react-native';
import { calcSizeForTv } from 'utils/index';

import FocusView from 'components/FocusView';

type TvSeasonsMenuProps = {
  items: CmsTag[];
  renderItem: any;
};

const TvSeasonsMenu: React.FC<TvSeasonsMenuProps> = ({ items, renderItem }) => {
  return (
    <View style={[styles.container, { marginBottom: calcSizeForTv(10) }]}>
      <FocusView>
        <FlatList
          data={items}
          keyExtractor={(item) => item.name}
          renderItem={renderItem}
          initialNumToRender={items.length}
          contentContainerStyle={styles.listContent}
          showsHorizontalScrollIndicator={false}
          horizontal
        />
      </FocusView>
    </View>
  );
};

export default TvSeasonsMenu;

const styles = StyleSheet.create({
  container: {
    borderBottomColor: '#7A8CFF',
    borderBottomWidth: 1,
  },
  listContent: {
    paddingHorizontal: 20,
  },
});
